<template>
<p>Prices in tBTC here</p>

</template>